import React from "react";

function TickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="31"
      viewBox="0 0 28 31"
      fill="none"
    >
      <g clip-path="url(#clip0_2012_28084)">
        <path
          d="M26.5747 6.92578C27.3071 7.6582 27.3071 8.84766 26.5747 9.58008L11.5747 24.5801C10.8423 25.3125 9.65283 25.3125 8.92041 24.5801L1.42041 17.0801C0.687988 16.3477 0.687988 15.1582 1.42041 14.4258C2.15283 13.6934 3.34229 13.6934 4.07471 14.4258L10.2505 20.5957L23.9263 6.92578C24.6587 6.19336 25.8481 6.19336 26.5806 6.92578H26.5747Z"
          fill="#28A745"
        />
      </g>
      <defs>
        <clipPath id="clip0_2012_28084">
          <path d="M0.875 0.75H27.125V30.75H0.875V0.75Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TickIcon;
